import { FaCheck, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Images from '../../../Images';
import { capitalizeFirstLetter, truncateText } from '../../../helpers';
import Tooltip from '../../Tooltip';

const TenantMiniProfile = ({
  name,
  profilePicture,
  kycStatus,
  flatName,
  isPoliceVerified = 0,
  isRentAgreementSigned = 0,
  truncateLength = 15,
}) => {

  // Small status pill
  const StatusPill = ({ ok, label }) => (
    <span
      className={`inline-flex items-center gap-1 text-[10px] px-2 rounded-full ${
        ok
          ? 'bg-green-50 text-green-700'
          : 'bg-gray-100 text-gray-500'
      }`}
    >
      {ok ? (
        <FaCheck size={7} />
      ) : (
        <FaTimes size={7} />
      )}
      {label}
    </span>
  );

  return (
    // <div
    //   className="flex items-start gap-3"
    // >
        <div
      className="flex items-center gap-3"
    >
      {/* Avatar */}
      <div className="relative shrink-0">
        <img
          src={profilePicture || Images.Avatar}
          alt={name}
          className="w-9 h-9 rounded-full object-cover"
        />

        {(kycStatus === 4 || kycStatus === 5) && (
          <span className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-1">
            <FaCheck className="text-white" size={8} />
          </span>
        )}
      </div>

      {/* Name + Status pills */}
      {/* <div className="flex flex-col min-w-0 gap-1"> */}
       <div >
        <span className="font-medium text-gray-700 truncate">
          <Tooltip label={flatName}>
            {capitalizeFirstLetter(truncateText(name, truncateLength))}
          </Tooltip>
        </span>

        {/* Police Verification + Rent Agreement */}
        {/* <div className="flex items-center gap-1.5">
          <StatusPill ok={isPoliceVerified === 1} label="PV" />
          <StatusPill ok={isRentAgreementSigned === 1} label="RA" />
        </div> */}
      </div>
    </div>
  );
};

export default TenantMiniProfile;